import withMetadataArgument from './withMetadataArgument.js'
import { isValidPhoneNumber as _isValidPhoneNumber } from '../../core/index.js'

export function isValidPhoneNumber() {
	return withMetadataArgument(_isValidPhoneNumber, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/isValidPhoneNumber.js
// module id = 1160
// module chunks = 22